const SectionTitle: React.FC<{ title: string; className?: string }> = (
  props,
) => {
  const { title, className } = props || {};
  return (
    <h2 className={`text-3xl text-center mb-[1em] ${className}`}>{title}</h2>
  );
};

export { SectionTitle };
